// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"884":"admin","966":"login"}[chunkId] + "." + {"884":"d76bf48f","966":"87f63b38"}[chunkId] + ".css";
};